module.exports = __webpack_public_path__ + "img/gallagher-flat-blue.8a4098a5.svg";